import { render } from "./Weather4.vue?vue&type=template&id=fa70d4f2"
import script from "./Weather4.vue?vue&type=script&lang=js"
export * from "./Weather4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__